var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.32 15V5.82H1.68V15h11.64zm0-13.36c.453 0 .847.167 1.18.5.333.333.5.727.5 1.18V15c0 .453-.167.84-.5 1.16-.333.32-.727.48-1.18.48H1.68c-.467 0-.863-.16-1.19-.48A1.564 1.564 0 0 1 0 15V3.32c0-.453.163-.847.49-1.18.327-.333.723-.5 1.19-.5h.82V0h1.68v1.64h6.64V0h1.68v1.64h.82zM11.68 7.5v1.64H10V7.5h1.68zm-3.36 0v1.64H6.68V7.5h1.64zM5 7.5v1.64H3.32V7.5H5z","fill":"currentColor","fillRule":"evenodd"}));
}

Calendar.defaultProps = {"viewBox":"0 0 15 17","width":"15","height":"17"};

module.exports = Calendar;

Calendar.default = Calendar;
